<template>
    <div class="relative">
        <textarea
            :id="id"
            v-model="modelValue"
            v-bind="$attrs"
            class="forms__field_input--textarea"
            :class="[sizeClass, { 'bg-gray-50 cursor-not-allowed': props.disabled }]"
            :placeholder="props.placeholder"
            :type="props.type"
            :dusk="dusk"
            :autocomplete="autocomplete"
            :required="required"
            :disabled="disabled"
            :rows="rows"
            @focus="emit('focus', $event)"
            @blur="emit('blur', $event)"
            @keyup="emit('keyup', $event)"
            @keydown="emit('keydown', $event)"
        />

        <div v-if="props.valid" class="absolute text-green-800 -translate-y-1/2 top-1/2 right-4">
            <icon icon="hero/outline/check" class="w-4 h-4"></icon>
        </div>

        <div v-if="props.invalid" class="absolute text-red-800 -translate-y-1/2 top-1/2 right-4">
            <icon icon="hero/outline/exclamation-circle" class="w-4 h-4"></icon>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { Ref } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

defineOptions({
    inheritAttrs: false,
});

const modelValue = defineModel({
    type: [String, undefined],
});

const emit = defineEmits<{
    (event: 'focus', content: any): void;
    (event: 'blur', content: any): void;
    (event: 'keyup', content: any): void;
    (event: 'keydown', content: any): void;
}>();

const props = withDefaults(defineProps<FieldComponent>(), {
    placeholder: undefined,
    size: 'base',
    type: 'text',
    dusk: null,
    valid: false,
    invalid: false,
    autocomplete: 'off',
    id: null,
    required: false,
    disabled: false,
    rows: 3,
});

const sizeClass: Ref<string> = computed((): string => {
    const sizes = {
        xs: 'forms__input--xs',
        sm: 'forms__input--sm',
        base: 'forms__input--base',
        lg: 'forms__input--lg',
        xl: 'forms__input--xl',
    };

    return `${sizes[props.size] ?? sizes.base} ${props.valid || props.invalid ? 'pr-8' : ''}`;
});

// Count newlines in value and set rows
const rows = ref(props.rows);

if (modelValue.value) {
    const newlines = modelValue.value.split('\n').length;
    rows.value = newlines > 3 ? newlines : 3;
}
</script>
